import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';

/**
 * Wrapper around loadash merge that doesn't change the initial objects, and
 * returns a merged object.
 * @param src - set of object
 */
export function mergedCopy(...src) {
  const dst = {};
  merge(dst, ...src);
  return dst;
}

/**
 * Returns the difference between a and b (a's complement union b)
 * @param a - the object compared against
 * @param b - the object containing fields that we recursively want.
 */
export function difference(a, b) {
  if (typeof b === 'undefined') {
    return;
  }
  if (typeof a === 'undefined') {
    return cloneDeep(b);
  }
  if (typeof a !== 'object') {
    return;
  }
  if (Array.isArray(a)) {
    return; // Don't handle intersecting arrays.
  }
  return Object.entries(b).reduce((dst, [key, bValue]) => {
    if (typeof bValue === 'object') {
      const res = difference(a[key], b[key]);
      if (!isEmpty(res)) {
        dst[key] = res;
      }
    } else if (typeof bValue !== 'undefined' && typeof a[key] === 'undefined') {
      dst[key] = bValue;
    }
    return dst;
  }, {});
}
